import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

interface IRestoreAcknowledgement {
  partnerId: string
  fYear: number
  ownerId: string
  programType: ProgramTypes
  isDistributor?: boolean
}

export const restoreAcknowledgement = ({
  partnerId,
  fYear,
  ownerId,
  programType,
  isDistributor,
}: IRestoreAcknowledgement) => {
  const url = proxy('/webservice/621/sp/v3/spJBPAcknowlegmentRestore/call')
  const [accessToken] = getTokens(ownerId)
  const headers = new HttpHeaders()

  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  const payload = {
    'p.PartnerId': partnerId,
    'p.FYear': fYear,
    'p.ProgramType': isDistributor ? null : programType,
  }
  return Rest.post({ url, payload, headers })
}
